import {Route, Routes, Outlet} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {ContactUssListWrapper} from './contact-us-list/ContactUsList'
const ContactUssPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/*'
          element={
            <>
              <PageTitle>Contact List</PageTitle>
              <ContactUssListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default ContactUssPage
